var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPanoramaHorizontalOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_444_7944",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.667969,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_444_7944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.14872 19.346C3.87822 19.3782 3.64714 19.3144 3.45547 19.1548C3.2638 18.9951 3.16797 18.7704 3.16797 18.4808V5.5385C3.16797 5.24883 3.2638 5.02417 3.45547 4.8645C3.64714 4.70484 3.87822 4.64108 4.14872 4.67325C4.37822 4.71808 4.73655 4.81325 5.22372 4.95875C5.71089 5.10425 6.31539 5.25267 7.03722 5.404C7.75905 5.55517 8.58789 5.69234 9.52372 5.8155C10.4597 5.9385 11.5078 6 12.668 6C13.8281 6 14.8746 5.9385 15.8075 5.8155C16.7401 5.69234 17.5673 5.55517 18.289 5.404C19.0108 5.25267 19.6137 5.10425 20.0977 4.95875C20.5817 4.81325 20.9385 4.71808 21.168 4.67325C21.4385 4.64108 21.6727 4.70484 21.8707 4.8645C22.0689 5.02417 22.168 5.24883 22.168 5.5385V18.4808C22.168 18.7704 22.0689 18.9951 21.8707 19.1548C21.6727 19.3144 21.4385 19.3782 21.168 19.346C20.9385 19.3012 20.5817 19.206 20.0977 19.0605C19.6137 18.915 19.0108 18.7634 18.289 18.6058C17.5673 18.4481 16.7401 18.3077 15.8075 18.1845C14.8746 18.0615 13.8281 18 12.668 18C11.5078 18 10.4597 18.0615 9.52372 18.1845C8.58789 18.3077 7.75905 18.4481 7.03722 18.6058C6.31539 18.7634 5.71089 18.915 5.22372 19.0605C4.73655 19.206 4.37822 19.3012 4.14872 19.346ZM4.30272 18.1423C5.65655 17.6909 7.03313 17.3653 8.43247 17.1653C9.8318 16.9653 11.2436 16.8653 12.668 16.8653C14.0923 16.8653 15.5041 16.9653 16.9035 17.1653C18.3028 17.3653 19.6794 17.6909 21.0332 18.1423V5.89225C19.6794 6.33325 18.3028 6.65059 16.9035 6.84425C15.504 7.03792 14.0921 7.13475 12.668 7.13475C11.2436 7.13475 9.8318 7.03792 8.43247 6.84425C7.03313 6.65059 5.65655 6.33325 4.30272 5.89225V18.1423Z",
    fill: "#A3A3A3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanoramaHorizontalOutline);
export default __webpack_public_path__ + "static/media/panorama_horizontalOutline.4e8e62f7221e68b809dcb1c31b61511c.svg";
export { ForwardRef as ReactComponent };